import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FaPlayCircle, FaMapMarkerAlt, FaRegClock, FaChevronDown } from 'react-icons/fa';
import slideWorship from '../Assets/Tus1.jpg';
import slideCommunity from '../Assets/maa.jpg';
import slideWord from '../Assets/APPPP.jpg';
import slideFamily from '../Assets/CityKidz.jpeg';
import './HeroSection.css';

const SLIDES = [
  { img: slideWorship, caption: 'Come And Worship', alt: 'A worship leader singing during a service at The City Church' },
  { img: slideCommunity, caption: 'Find Your Community', alt: 'Members of The City Church celebrating together' },
  { img: slideWord, caption: 'Grow In The Word', alt: 'Teaching from God’s word during a Sunday gathering' },
  { img: slideFamily, caption: 'For The Whole Family', alt: 'A child full of joy at The City Church' },
];

const INTERVAL = 6000;

function HeroSection() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const timer = useRef(null);

  const prefersReduced = typeof window !== 'undefined'
    && window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const go = useCallback((i) => setActive((i + SLIDES.length) % SLIDES.length), []);

  useEffect(() => {
    if (prefersReduced || paused) return undefined;
    timer.current = setTimeout(() => setActive((a) => (a + 1) % SLIDES.length), INTERVAL);
    return () => clearTimeout(timer.current);
  }, [active, paused, prefersReduced]);

  return (
    <section
      className="hero"
      aria-label="Welcome to The City Church"
      aria-roledescription="carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocusCapture={() => setPaused(true)}
      onBlurCapture={() => setPaused(false)}
    >
      <div className="hero__slides">
        {SLIDES.map((s, i) => (
          <div
            key={s.img}
            className={`hero__slide${i === active ? ' is-active' : ''}`}
            aria-hidden="true"
          >
            <img
              className="hero__img"
              src={s.img}
              alt=""
              loading={i === 0 ? 'eager' : 'lazy'}
              decoding="async"
            />
          </div>
        ))}
      </div>

      <div className="hero__scrim" aria-hidden="true" />

      <div className="hero__inner tcc-container">
        <div className="hero__content">
          <h1 className="tcc-sr-only">The City Church</h1>

          <div className="hero__captions" aria-hidden="true">
            {SLIDES.map((s, i) => (
              <p key={s.caption} className={`hero__caption${i === active ? ' is-active' : ''}`}>
                {s.caption}
              </p>
            ))}
          </div>

          <div className="hero__chips">
            <span className="tcc-chip"><FaRegClock aria-hidden="true" /> Sundays · 9:00 &amp; 11:00 AM</span>
            <span className="tcc-chip"><FaMapMarkerAlt aria-hidden="true" /> Luzira · Kirinya · Iganga</span>
          </div>

          <div className="hero__actions">
            <Link to="/join-mc" className="tcc-btn tcc-btn--accent tcc-btn--lg">
              Plan Your Visit
            </Link>
            <a
              className="tcc-btn tcc-btn--outline-on-dark tcc-btn--lg"
              href="https://www.youtube.com/@thecitychurch-luzira2585"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaPlayCircle aria-hidden="true" /> Watch Online
            </a>
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div className="hero__dots" role="tablist" aria-label="Choose a slide">
        {SLIDES.map((s, i) => (
          <button
            key={s.caption}
            type="button"
            className={`hero__dot${i === active ? ' is-active' : ''}`}
            aria-label={`${s.caption} (slide ${i + 1} of ${SLIDES.length})`}
            aria-selected={i === active}
            role="tab"
            onClick={() => go(i)}
          />
        ))}
      </div>

      <a className="hero__scroll" href="#welcome" aria-label="Scroll to content">
        <FaChevronDown aria-hidden="true" />
      </a>
    </section>
  );
}

export default HeroSection;
